/* eslint-disable import/prefer-default-export */
export const UPC_VALIDATION_MESSAGES = {
  SUCCESS: 'Item successfully added to bag.',
  ERROR: 'Please try again, a technical issue occurred. If you continue to experience difficulties you can order by phone at 1-800-289-6229.',
  COLOR_NOT_SELECTED: 'Please select a color.',
  SIZE_NOT_SELECTED: 'Please select a size.',
  TYPE_NOT_SELECTED: 'Please select an orientation',
  TRAIT_NOT_SELECTED: 'Please select a',
  VALUE_NOT_SELECTED: 'Please select a value.',
  SIZE_COLOR_NOT_AVAILABLE: 'This color/size combination is not available.',
  COMBINATION_NOT_AVAILABLE: 'combination is not available.',
  VALUE_COLOR_NOT_AVAILABLE: 'This color/value combination is not available.',
};
